import { setMwValue, getMwValue, setMwToken, getMwToken } from './utils';
import {API_URL} from './application';

const ACCOUNTTRANSACTIONS_GET_URL = API_URL+'api/LoanAccountTransactions'
const ACCOUNTTRANSACTIONS_POST_URL  = API_URL+'api/LoanAccountTransactions'
const ACCOUNTTRANSACTIONS_MATCH_URL = API_URL+'api/LoanAccountTransactions/TryMatchAccountTransaction?id='
const ACCOUNTTRANSACTIONS_MATCH_ALL_URL = API_URL+'api/LoanAccountTransactions/TryMatchAllAccountTransaction?id='
const ACCOUNTTRANSACTIONS_REMOVE_URL = API_URL+'api/LoanAccountTransactions/TryDeleteAccountTransaction?id='
const REQUEST_ACCOUNTBALANCE_URL = API_URL+'api/LoanAccountTransactions/TryGetAccountBalance?ValueDate='
const BKTRANSACTIONS_GET_URL = API_URL+'api/LoanAccountTransactions/BkTransactions'
const UPLOADFILE_POST_URL = API_URL +'api/LoanAccountTransactions/UploadFile'


export const REQUEST_UPLOAD_FILE = 'REQUEST_UPLOAD_FILE'
export const RECEIVE_UPLOAD_FILE_SUCCESS = 'RECEIVE_UPLOAD_FILE_SUCCESS'


export const REQUEST_BKTRANSACTIONS = 'REQUEST_BKTRANSACTIONS'
export const RECEIVE_BKTRANSACTIONS_SUCCESS = 'RECEIVE_BKTRANSACTIONS_SUCCESS'
export const RECEIVE_BKTRANSACTIONS_ERROR = 'RECEIVE_BKTRANSACTIONS_ERROR'


export const REQUEST_ACCOUNTTRANSACTIONS = 'REQUEST_ACCOUNTTRANSACTIONS'
export const RECEIVE_ACCOUNTTRANSACTIONS_SUCCESS = 'RECEIVE_ACCOUNTTRANSACTIONS_SUCCESS'
export const RECEIVE_ACCOUNTTRANSACTIONS_ERROR = 'RECEIVE_ACCOUNTTRANSACTIONS_ERROR'

export const REQUEST_ACCOUNTTRANSACTIONS_MATCH = 'REQUEST_ACCOUNTTRANSACTIONS_MATCH'
export const RECEIVE_ACCOUNTTRANSACTIONS_MATCH_SUCCESS = 'RECEIVE_ACCOUNTTRANSACTIONS_MATCH_SUCCESS'

export const RECEIVE_ACCOUNTBALANCE_SUCCESS = 'RECEIVE_ACCOUNTBALANCE_SUCCESS' 
export const REQUEST_ACCOUNTBALANCE = 'REQUEST_ACCOUNTBALANCE' 


export const REQUEST_ACCOUNTTRANSACTIONS_REMOVE = 'REQUEST_ACCOUNTTRANSACTIONS_REMOVE'
export const RECEIVE_ACCOUNTTRANSACTIONS_REMOVE_SUCCESS = 'RECEIVE_ACCOUNTTRANSACTIONS_REMOVE_SUCCESS'


export const REQUEST_ACCOUNTTRANSACTIONS_SAVE = 'REQUEST_ACCOUNTTRANSACTIONS_SAVE'
export const RECEIVE_ACCOUNTTRANSACTIONS_SAVE_SUCCESS = 'RECEIVE_ACCOUNTTRANSACTIONS_SAVE_SUCCESS'
export const RECEIVE_ACCOUNTTRANSACTIONS_SAVE_ERROR = 'RECEIVE_ACCOUNTTRANSACTIONS_SAVE_ERROR'


export function uploadFile(form) {
        return (dispatch, getState) => {        
            const token = getState().auth.token;  
            dispatch({type: REQUEST_UPLOAD_FILE});
            const data = new FormData();
            data.append('file',form, form.name );
            return fetch(UPLOADFILE_POST_URL, {
                  method: 'POST',
                  headers: {          
                        'authorization' : 'bearer '+token,            
                        'Content-Type': 'multipart/form-data;charset=utf-8'
                  },
                  body: form
             }).then (  
                response => {
                     return response.json(); }).then (
                        response => {     
                            return dispatch ({type : RECEIVE_UPLOAD_FILE_SUCCESS, loanAccountTransaction: response })
                        },                    
                error => {
                    throw error;
                }                                
                     )  
        }
}

export function postLoanAccountTransaction(loanAccountTransaction) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_ACCOUNTTRANSACTIONS_SAVE, LoanAccountTransaction: loanAccountTransaction});        
         return fetch(ACCOUNTTRANSACTIONS_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...loanAccountTransaction
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_ACCOUNTTRANSACTIONS_SAVE_SUCCESS, loanAccountTransaction: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function tryMatchAccountTransaction(id) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_ACCOUNTTRANSACTIONS_MATCH, LoanAccountTransactionId: id});        
         return fetch(ACCOUNTTRANSACTIONS_MATCH_URL+id, {
            method: 'GET',
            headers: {      
                'authorization' : 'bearer '+token
              }
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_ACCOUNTTRANSACTIONS_MATCH_SUCCESS, loanAccountTransaction: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function tryMatchAllAccountTransaction(id) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_ACCOUNTTRANSACTIONS_MATCH, LoanAccountTransactionId: id});        
         return fetch(ACCOUNTTRANSACTIONS_MATCH_ALL_URL+id, {
            method: 'GET',
            headers: {      
                'authorization' : 'bearer '+token
              }
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_ACCOUNTTRANSACTIONS_MATCH_SUCCESS, loanAccountTransaction: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function tryDeleteAccountTransaction(id) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_ACCOUNTTRANSACTIONS_REMOVE, trn: id});        
         return fetch(ACCOUNTTRANSACTIONS_REMOVE_URL+id, {
            method: 'GET',
            headers: {      
                'authorization' : 'bearer '+token
              }
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_ACCOUNTTRANSACTIONS_REMOVE_SUCCESS, id: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function getFetchloanAccountTransactions ()  {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_ACCOUNTTRANSACTIONS});        
         return fetch(ACCOUNTTRANSACTIONS_GET_URL, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_ACCOUNTTRANSACTIONS_SUCCESS, loanAccountTransactions: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function getFetchBkTransactions (beginDate, endDate)  {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_BKTRANSACTIONS});        
         return fetch(BKTRANSACTIONS_GET_URL,{
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                bDate: beginDate,
                eDate: endDate
              }
            )
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_BKTRANSACTIONS_SUCCESS, loanAccountTransactions: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}


export function tryGetAccountBalance(valueDate) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_ACCOUNTBALANCE});        
         return fetch(REQUEST_ACCOUNTBALANCE_URL+valueDate, {
            method: 'GET',
            headers: {      
                'authorization' : 'bearer '+token
              }
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_ACCOUNTBALANCE_SUCCESS, balance: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}